import React from 'react';

interface UserPermissionsIconProps {
  className?: string;
}

const UserPermissionsIcon: React.FC<UserPermissionsIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
    >
      <path d="m20 4.5c0 .551-.449 1-1 1h-1c-.551 0-1-.449-1-1s.449-1 1-1h1c.551 0 1 .449 1 1zm4-.977v3.477c0 3.966-3.639 5.738-4.754 6.187l-.812.327-.783-.392c-1.091-.546-4.651-2.6-4.651-6.122v-3.477c0-1.031.658-1.941 1.637-2.265l3.863-1.258 3.863 1.258c.979.324 1.637 1.234 1.637 2.265zm-3 .977c0-1.103-.897-2-2-2h-1c-1.103 0-2 .897-2 2s.897 2 2 2v4h2v-1h-1v-3c1.103 0 2-.897 2-2zm-13 5.5c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm4 5v-1.5c0-1.378-1.121-2.5-2.5-2.5h-3c-1.379 0-2.5 1.122-2.5 2.5v1.5h2v-1.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5v1.5zm10-1.028v3.028h-20v-14c0-.551.448-1 1-1h8.293c.292-.795.798-1.494 1.481-2h-9.774c-1.654 0-3 1.346-3 3v16h11v3h-5v2h12v-2h-5v-3h11v-6.732c-.636.718-1.34 1.269-2 1.704z"/>
    </svg>
  );
};

export default UserPermissionsIcon;
